import { Button } from '@library/components/buttons';
import type { FormattedChannel } from '@library/types/alerts';
import { RssIcon } from '@heroicons/react/24/outline';
import { useChannels } from '@bo-hooks/alerts/useChannels';
import { useState } from 'react';

export interface SubscribeChannelProps {
  selectedChannelId: number;
  isUserSubscribedCheck: boolean;
  setChannels: (channels: Array<FormattedChannel>) => void;
  setIsUserSubscribedCheck: (subscribeCheck: boolean) => void;
}

export const SubscribeChannelButton = ({
  selectedChannelId,
  isUserSubscribedCheck,
  setChannels,
  setIsUserSubscribedCheck
}: SubscribeChannelProps) => {
  const { handleChannelAction, allChannelsData } = useChannels({});

  const [isButtonClicked, setButtonClicked] = useState(false);

  const handleSubscribeUnsubscribe = async () => {
    const buttonClick = isButtonClicked;
    setButtonClicked(!buttonClick);
    const action = isUserSubscribedCheck ? 'unsubscribe' : 'subscribe';
    const success = await handleChannelAction(
      action,
      selectedChannelId,
      setButtonClicked
    );

    if (success) {
      setIsUserSubscribedCheck(!isUserSubscribedCheck);
      if (allChannelsData) {
        const updatedChannels = allChannelsData.map((channel) =>
          channel.id === selectedChannelId
            ? { ...channel, isUserSubscribed: !isUserSubscribedCheck }
            : channel
        );

        setChannels(updatedChannels);
      }
    }
  };

  return (
    <Button onClick={handleSubscribeUnsubscribe} disabled={isButtonClicked}>
      <RssIcon
        className={`${isUserSubscribedCheck ? 'stroke-soClean-100' : 'stroke-soFresh-190'} size-4`}
      />
    </Button>
  );
};
